import { Icon } from '@cbhq/cds-web/icons/Icon';
import { HStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';

export type EditMemberActivitySummaryProps = {
  joinedLabel?: string;
  lastActiveLabel?: string;
};

export function EditMemberActivitySummary({
  joinedLabel,
  lastActiveLabel,
}: EditMemberActivitySummaryProps) {
  if (!joinedLabel && !lastActiveLabel) {
    return null;
  }

  return (
    <HStack width="100%" alignItems="center" gap={4}>
      {joinedLabel ? (
        <HStack alignItems="center" gap={1}>
          <Icon name="login" size="s" color="fgMuted" />
          <Text as="span" font="label2" color="fgMuted" noWrap>
            {joinedLabel}
          </Text>
        </HStack>
      ) : null}
      {lastActiveLabel ? (
        <HStack alignItems="center" gap={1}>
          <Icon name="clock" size="s" color="fgMuted" />
          <Text as="span" font="label2" color="fgMuted" noWrap>
            {lastActiveLabel}
          </Text>
        </HStack>
      ) : null}
    </HStack>
  );
}
